<script lang="ts" setup>
import LiveStatus from "@/components/status/LiveStatus.vue";
import { useRouteInfo } from "@/composable/route-info";
import { Site } from "@soft-db/monitoring-api-client";
import { Progress } from "@soft-db/ui";
import Header from "./Header.vue";
import Info from "./Info.vue";
import Links from "./Links.vue";
import Location from "./Location.vue";

const emit = defineEmits(["close"]);
const { site } = defineProps({
	site: { type: Object as PropType<Site>, required: true },
	isLoading: Boolean,
});

const { currentRoute } = useRouteInfo();
const page = computed(() => {
	switch (currentRoute.value) {
		case "dashboard":
			return "dashboard";

		case "integrity":
			return "integrity";

		case "site":
		case "station":
			return "settings";

		default:
			return "map";
	}
});
</script>

<template>
	<div class="bg-base-100 min-w-80 rounded-t-3xl px-2 py-1 shadow-md md:rounded-md">
		<Progress v-if="isLoading" class="w-full" color="primary" />
		<template v-else>
			<Header objectType="site" :title="site.name" @close="() => emit('close')" />
			<Info
				sourceType="site"
				:sourceId="site.id"
				:src="site.imageUrl"
				:description="site.description"
			/>
			<Location v-if="site.coordinates" :coordinates="site.coordinates" />
			<LiveStatus sourceType="site" :sourceId="site.id" class="flex w-full py-1" xs />
			<Links :page="page" :site="site" />
		</template>
	</div>
</template>
